import React from 'react'

export const FiscalContext = React.createContext({})